/**
 * Verification use cases – verify a lift (others only), 20 verifications = auto-verified.
 */
import { verificationRepo } from '../../data/repositories/VerificationRepository';

const VERIFICATION_THRESHOLD = 20;

/** Add a verification. Caller must ensure currentUser is not the workout owner. */
export async function verifyWorkout(workoutId, currentUserId, workoutOwnerId) {
  if (currentUserId === workoutOwnerId) {
    return { ok: false, error: 'You cannot verify your own lift.' };
  }
  const result = await verificationRepo.add(workoutId, currentUserId);
  return result.added ? { ok: true } : { ok: false, error: 'You already verified this lift.' };
}

/** Get the set of workout IDs (from the given list) that the user has verified. */
export async function getVerifiedWorkoutIdsByUser(userId, workoutIds) {
  return verificationRepo.getVerifiedWorkoutIdsByUser(userId, workoutIds);
}
